import React, { memo } from 'react';
import { ResponsivePie } from '@nivo/pie';
import { Box, Flex, Text } from '@chakra-ui/react';
import { COLORS } from '../routes/home/model/TransactionBarCharProps';
import NoAvailable from './NoAvailable';

// Naranja del portal (button-primary.500 / primary.800), en vez del azul original.
const fillColor = '#F14A1D';

const CustomLegend = ({ data }: { data: any }) => {
  return (
    <Flex  direction="column" gap="0.02rem" width={["100%", "60%"]} >
      {data.map((item: any, index: any) => {
        return (
          <Flex alignItems="center" key={item.id}>
            <div
              style={{
                width: '1.2em',
                height: '1.2em',
                borderRadius: '.2em',
                backgroundColor: item.color,
              }}
            />

            <Flex marginLeft="l" width="full" justifyContent="space-between">
              <Text
                color="black"
                fontSize="s"
              >
                {item.id}
              </Text>
              <Text>
                {`${item.value}%`}
              </Text>
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};

const DonutChart = ({ data, title }: {data: any, title: string}) => {
  return <>
    <Box width="full">
      {data.length > 0 ? (
        <Flex direction="column" alignContent="center">
          <Box justifyItems="center">
            <Text fontSize="l" fontWeight="bold" width={["100%", "60%"]}>{title}</Text>
          </Box>
          <Box height="14em" p="l" pt="0">
            <ResponsivePie
              theme={{
                axis: {
                  domain: {
                    line: {
                      stroke: fillColor,
                    },
                  },
                  legend: {
                    text: {
                      fill: fillColor,
                    },
                  },
                  ticks: {
                    line: {
                      stroke: fillColor,
                      strokeWidth: 1,
                    },
                    text: {
                      fill: fillColor,
                    },
                  },
                },
                legends: {
                  text: {
                    fill: fillColor,
                  },
                },
                tooltip: {
                  container: {
                    background: fillColor,
                    color: fillColor,
                  },
                },
              }}
              data={data}
              margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
              innerRadius={0.6}
              padAngle={0.7}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              borderWidth={1}
              colors={{ datum: 'data.color' }}
              borderColor={{
                from: 'color',
                modifiers: [
                  [
                    'darker',
                    0.2,
                  ],
                ],
              }}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor="#333333"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={{ from: 'color' }}
              arcLabelsSkipAngle={10}
              arcLabel={(datum) => `${datum.value}%`}
              enableArcLinkLabels={false}
              arcLabelsTextColor="#FFFFFF"
              defs={[
                {
                  id: 'dots',
                  type: 'patternDots',
                  background: 'inherit',
                  color: 'rgba(255, 255, 255, 0.3)',
                  size: 4,
                  padding: 1,
                  stagger: true,
                },
                {
                  id: 'lines',
                  type: 'patternLines',
                  background: 'inherit',
                  color: 'rgba(255, 255, 255, 0.3)',
                  rotation: -45,
                  lineWidth: 6,
                  spacing: 10,
                },
              ]}

              legends={[]}
            />
          </Box>
          <Box paddingX="xl" justifyItems="center">
            <CustomLegend data={data} />
          </Box>
        </Flex>
      ) : (
        <NoAvailable />
      )}
    </Box>
  </>;
};

export default memo(DonutChart);
